/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { useMedia } from '@api/hooks';

const SectionItem = ({ image, description, handleEdit, children }) => {
  const { media } = useMedia(image);

  return (
    <InfoItem description={description} image={media.src} onClick={handleEdit}>
      {children}
    </InfoItem>
  );
};

export default SectionItem;
